import React, { useState } from 'react';
import defar from '../../../assets/img/Mask group.png';
import SignUpForm from '../SignUpForm'; // Import the SignUpForm component

const DigitalMarketingInfo = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleSubscribeClick = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="relative  overflow-hidden flex flex-col md:flex-row">
            {/* Left Sidebar */}
            <div className="md:w-1/6 sm:w-full md:fixed md:left-0 md:top-28 m-4 px-6 py-8 bg-[#FD5F20] bg-opacity-40  rounded-xl transform transition-transform hover:scale-105 hover:shadow-2xl">
                <h1 className="font-bold">In this article</h1>
                <p>
                    Top 10 digital marketing courses in 2024 <br />
                    Online Digital Marketing courses - FAQ <br />
                    Methodology <br />
                    What to Do Next?
                </p>
            </div>

            {/* Right Sidebar */}
            <div className="md:w-1/6 sm:w-full md:fixed md:right-0 md:top-28 m-4 px-6 py-8 bg-[#FD5F20] bg-opacity-40  rounded-xl transform transition-transform hover:scale-105 hover:shadow-2xl">
                {/* Profile Image */}
                <div className="flex justify-center mb-4">
                    <img
                        src={defar}
                        
                        title='Ato creative Digital marketing manager'
                        alt="Samson Taddese"
                        className="w-24 h-24 rounded-full border-4 border-[#FD5F20]"
                    />
                </div>

                {/* Profile Details */}
                <h2 className="text-xl font-semibold text-gray-800 mb-2">Abel M.</h2>
                <p className="text-sm text-gray-600 mb-2">Digital Marketing Specialist</p>

                {/* Profile Description */}
                <p className="text-sm text-gray-500">
                    Get access to exclusive tips and strategies Samson shares with our newsletter subscribers.
                </p>

                {/* Call to Action Button */}
                <button
                    onClick={handleSubscribeClick}
                    className="mt-4 w-full py-2 bg-[#FD5F20] text-white rounded-lg  hover:bg-indigo-700 transition-colors"
                >
                    Subscribe Now
                </button>
            </div>

            {/* Main Content Area */}
            {/* <div className="flex-1 md:ml-1/6 md:mr-1/6 px-8 py-2 text-gray-800">
                <p className="mb-1">
                    Digital marketing has become the go-to marketing strategy for small businesses and enterprises alike.
                </p>
                <div>
                    <h2 className="text-xl font-semibold mb-1">This guide will discuss:</h2>
                    <ul className="list-disc list-inside pl-4">
                        <li>What digital marketing is</li>
                        <li>The benefits of digital marketing</li>
                        <li>Types of digital marketing</li>
                        <li>How to do digital marketing</li>
                    </ul>
                </div>
            </div> */}

            {/* Modal for Sign Up Form */}
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg  p-6 w-11/12 md:w-1/3">
                        <h2 className="text-xl font-bold mb-4">Sign Up</h2>
                        <SignUpForm closeModal={closeModal} />
                        <button onClick={closeModal} className="mt-4 inline-block text-gray-600">
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DigitalMarketingInfo;